import { api } from './api';

interface DebugSettings {
  enabled: boolean;
  updated_by?: string;
  updated_at?: string;
}

export const adminApi = {
  /**
   * Gets the current global debug settings
   * @returns Promise with the debug settings data
   */
  getDebugSettings: async (): Promise<DebugSettings> => {
    const response = await api.get<DebugSettings>('/settings/debug', {
      isGlobal: true
    });
    return response.data;
  },

  /**
   * Updates the global debug settings
   * @param enabled - Whether debug mode should be enabled
   * @returns Promise with the updated debug settings
   */
  updateDebugSettings: async (enabled: boolean): Promise<{ enabled: boolean }> => {
    const response = await api.put<{ enabled: boolean }>('/settings/debug', { enabled }, {
      isGlobal: true
    });
    return response.data;
  }
};
